import config from '@/config';
import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
export var useGetMyTeams = function () {
    var intl = useIntl();
    var _a = useQuery([TaskQueryKey.MyTeams], function () {
        return api.base
            .get("".concat(config.appUrls.api, "/api/Team/MyTeams"))
            .then(function (res) { return res.data; });
    }, {
        enabled: true,
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    }), data = _a.data, isLoading = _a.isLoading, error = _a.error, refetch = _a.refetch;
    return {
        data: data,
        error: error,
        isLoading: isLoading,
        refetch: refetch,
    };
};
